<template>
  <div class="row mt-4" v-if="embudo.entradas > 0">
    <div class="col-12">
      <div class="card ficha-listado">
        <div class="px-4 pb-4 card-body">

          <div class="mb-4">
            <h6 class="mb-0 panel-section-title">Embudo de conversión</h6>
            <p class="text-xs opacity-7 mb-0">De suscriptores a compradores recurrentes</p>
          </div>

          <div class="funnel-wrap">

            <div
              v-for="(step, i) in steps"
              :key="i"
              class="funnel-step-row"
            >
              <!-- Flecha con ratio entre pasos -->
              <div v-if="i > 0" class="funnel-arrow">
                <div class="funnel-arrow__line"></div>
                <div class="funnel-arrow__badge" :class="ratioClass(ratios[i-1])">
                  {{ fmtPct(ratios[i-1]) }}
                </div>
              </div>

              <!-- Barra del paso -->
              <div class="funnel-bar-row">
                <div class="funnel-bar-wrap">
                  <div
                    class="funnel-bar"
                    :class="`funnel-bar--${step.color}`"
                    :style="{ width: barWidth(step.value) }"
                  >
                    <span class="funnel-bar__val">{{ step.value.toLocaleString('es-ES') }}</span>
                  </div>
                </div>
                <div class="funnel-meta">
                  <span class="funnel-meta__label">{{ step.label }}</span>
                  <span class="funnel-meta__desc">{{ step.desc }}</span>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PanelTipsterEmbudo",
  props: {
    embudo: {
      type: Object,
      default: () => ({ entradas: 0, suscritos: 0, compradores: 0, recurrentes: 0 }),
    },
  },
  computed: {
    steps() {
      return [
        {
          label: "Entradas únicas",
          desc:  "Total de personas que alguna vez se suscribieron",
          value: this.embudo.entradas   || 0,
          color: "azul",
        },
        {
          label: "Suscritos activos",
          desc:  "Actualmente en algún canal del tipster",
          value: this.embudo.suscritos  || 0,
          color: "cyan",
        },
        {
          label: "Compradores únicos",
          desc:  "Han realizado al menos una compra completada",
          value: this.embudo.compradores || 0,
          color: "naranja",
        },
        {
          label: "Compradores recurrentes",
          desc:  "Han realizado más de una compra completada",
          value: this.embudo.recurrentes || 0,
          color: "verde",
        },
      ];
    },
    ratios() {
      const s = this.steps;
      return s.slice(1).map((step, i) => {
        const prev = s[i].value;
        return prev > 0 ? (step.value / prev) * 100 : null;
      });
    },
    maxValue() {
      return Math.max(...this.steps.map(s => s.value), 1);
    },
  },
  methods: {
    barWidth(val) {
      return `${Math.max((val / this.maxValue) * 100, val > 0 ? 4 : 0)}%`;
    },
    fmtPct(ratio) {
      if (ratio === null) return "—";
      return `${ratio.toFixed(1)}%`;
    },
    ratioClass(ratio) {
      if (ratio === null) return "badge-neutral";
      if (ratio >= 50) return "badge-verde";
      if (ratio >= 20) return "badge-naranja";
      return "badge-rojo";
    },
  },
};
</script>

<style scoped>
.funnel-wrap {
  display: flex;
  flex-direction: column;
  gap: 0;
  max-width: 680px;
}

/* Fila de barra */
.funnel-bar-row {
  display: flex;
  align-items: center;
  gap: 16px;
}

.funnel-bar-wrap {
  flex: 1;
  min-width: 0;
}

.funnel-bar {
  height: 44px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding: 0 14px;
  transition: width .4s ease;
  min-width: 44px;
}

.funnel-bar--azul    { background: linear-gradient(90deg, var(--q-gold), var(--q-gold-hover)); }
.funnel-bar--cyan    { background: linear-gradient(90deg, #00acc1, #26c6da); }
.funnel-bar--naranja { background: linear-gradient(90deg, #fb8c00, #ffa726); }
.funnel-bar--verde   { background: linear-gradient(90deg, #43a047, #66bb6a); }

.funnel-bar__val {
  color: #fff;
  font-size: 16px;
  font-weight: 800;
  font-family: var(--q-font-mono);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.funnel-meta {
  display: flex;
  flex-direction: column;
  min-width: 180px;
  max-width: 220px;
}
.funnel-meta__label {
  font-size: 13px;
  font-weight: 700;
  color: var(--q-text);
  font-family: var(--q-font-ui);
}
.funnel-meta__desc {
  font-size: 11px;
  color: var(--q-muted);
  font-family: var(--q-font-ui);
  margin-top: 2px;
  line-height: 1.3;
}

/* Flecha + badge ratio */
.funnel-arrow {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 0;
  padding-left: 14px;
}
.funnel-arrow__line {
  width: 2px;
  height: 20px;
  background: var(--q-border);
  border-radius: 2px;
}
.funnel-arrow__badge {
  font-size: 11px;
  font-weight: 700;
  font-family: var(--q-font-mono);
  font-variant-numeric: tabular-nums;
  padding: 2px 9px;
  border-radius: 20px;
}
.badge-verde   { background: var(--q-green-soft); color: var(--q-green); }
.badge-naranja { background: var(--q-amber-soft); color: var(--q-amber); }
.badge-rojo    { background: var(--q-red-soft);   color: var(--q-red); }
.badge-neutral { background: var(--q-hover);      color: var(--q-muted); }
</style>
